import { render, staticRenderFns } from "./AppChannelFeeListSidebar.vue?vue&type=template&id=c90ba638&"
import script from "./AppChannelFeeListSidebar.vue?vue&type=script&lang=js&"
export * from "./AppChannelFeeListSidebar.vue?vue&type=script&lang=js&"
import style0 from "./AppChannelFeeListSidebar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports